<template>
    <div>
        <InputField
            type="text" 
            name="format" 
            label="Format" 
            v-model="constraints.custom_data.datetime.format" 
            @error="fieldError"
            :rules="{required: false, default: 'yyyy-MM-dd HH:mm'}"
        />

         <b-form-group
            description=""
            label="12h Clock"
            label-for="is12h"
            :label-cols="3"
            :horizontal="false">
                <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.datetime.is12h"/>
        </b-form-group>

        <b-form-group
            description=""
            label="Disable past dates"
            label-for="disablePastDates"
            :label-cols="3"
            :horizontal="false">
                <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.custom_data.datetime.disablePastDates"/>
        </b-form-group>

        <InputField 
            description="Interval in which hours are displayed"
            type="text" 
            name="hourStep" 
            label="Hour step" 
            v-model.number="constraints.custom_data.datetime.hourStep" 
            @error="fieldError"
            :rules="{required: false}"
        />

        <InputField 
            description="Interval in which minutes are displayed"
            type="text" 
            name="minuteStep" 
            label="Minute step" 
            v-model.number="constraints.custom_data.datetime.minuteStep" 
            @error="fieldError"
            :rules="{required: false, length: {min: 1, max: 30}, expression: this.validate}"
        />

        <InputField 
            v-if="!is12h"
            description="Available time for selection, ex: 9-17"
            type="text" 
            name="availableTime" 
            label="Available time" 
            v-model="constraints.custom_data.datetime.availableHours" 
            @error="fieldError"
            :rules="{required: false, regex: '(([0-9]*)|[0-9])-(([0-9]*)|[0-9])'}"
        />

         <InputField 
            v-else
            description="Available time for selection, ex: 9am-5pm"
            type="text" 
            name="availableTime" 
            label="Available time" 
            v-model="constraints.custom_data.datetime.availableHours" 
            @error="fieldError"
            :rules="{required: false, regex: '([0-9]{1,2}(am|pm))-([0-9]{1,2}(am|pm))'}"
        />
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import InputField from '@/components/form/Input'

export default {
    components: {
        cSwitch,
        InputField
    },
    props: {
        value: {
            type: Object
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        errors(val) {
            this.$emit('error', val[0])
        }
    },
    computed: {
        constraints() {
            let base = this.value

            base.custom_data = base.custom_data || {
                datetime: {
                    is12h: false,
                    hourStep: 1,
                    minuteStep: 1,
                    format: "yyyy-MM-dd HH:mm",
                    availableHours: null,
                    disablePastDates: false
                }
            }

            base.custom_data.datetime = base.custom_data.datetime || {}

            return base;
        },

        availableTimeRegex() {
            if (this.constraints.custom_data.datetime.is12h) {
                return '([0-9]{1,2}(am|pm))-([0-9]{1,2}(am|pm))'
            }

            return '(([0-9]*)|[0-9])-(([0-9]*)|[0-9])'
        },

        is12h() {
            return this.constraints.custom_data.datetime.is12h
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        validate(val) {
            if (val == NaN) {
                return []
            }

            if (60 % val != 0) {
                return ['Must be a value evenly divided into 60']
            }

            return []
        }
    }
    
}
</script>